import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'sign-in',
    loadChildren: () =>
      import('./pages/sign-in/sign-in.module').then(m => m.SignInModule),
  },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./pages/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then(m => m.ProfileModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./pages/search/search.module').then(m => m.SearchModule),
  },
  {
    path: 'restaurants/:restaurantKey',
    loadChildren: () =>
      import('./pages/restaurant/restaurant.module').then(
        m => m.RestaurantModule,
      ),
  },
  {
    path: 'reservation',
    loadChildren: () =>
      import('./pages/reservation/reservation.module').then(
        m => m.ReservationModule,
      ),
  },
  {
    path: 'reservations',
    loadChildren: () =>
      import('./pages/reservations/reservations.module').then(
        m => m.ReservationsModule,
      ),
  },
  {
    path: 'withdraw',
    loadChildren: () =>
      import('./pages/withdraw/withdraw.module').then(m => m.WithdrawModule),
  },
  {
    path: 'area-restaurants/:areaCode',
    loadChildren: () =>
      import('./pages/area-restaurants/area-restaurants.module').then(
        m => m.AreaRestaurantsModule,
      ),
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./pages/maintenance/maintenance.module').then(
        m => m.MaintenanceModule,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'search',
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./pages/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
